module.exports = "<div class=\"no_active_match\">\n  No active Match\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/scoreboard/scoreboard.component.html
// module id = 413
// module chunks = 2